import React, {useState} from 'react'
import { Box, Typography, TextField, Button } from '@mui/material';
import RateStar from '../../assets/rate-star.svg';
import BasicRating from './Tes';
import Rating from '@mui/material/Rating';
import Write from '../../assets/write.svg';
import { toast } from "react-hot-toast";
import { useParams } from 'react-router-dom';



const RateContent = ({setOnClose}) => {
    const [value, setValue] = useState(1);
    const [description, setDecription] = useState('')
    const formData={
            description: description,
            rateValue:value
          }
          
    const handleChange = (event) => {
        setDecription(event.target.value);
    };
    const handleClose = ()=>{
        setOnClose(false)      
    }
    const handleReviewSubmit = ()=>{
        console.log(formData)
        toast.success("Thank you for your honest review", {
            duration: 4000, // Duration for the toast to stay visible
            position: "top-right", // Position of the toast (can be 'top-left', 'top-right', 'bottom-left', 'bottom-right')
          });
    }
  return (
    <Box>
        <Box sx={{mt:4}}>
            <Typography variant='h5' sx={{color:'rgba(86, 4, 246, 1)'}}>
                Rate and Review your Purchase
            </Typography>
            <Typography sx={{fontSize:'1rem', my:2, color:'rgba(18, 18, 18, 0.8)'}}>
                Your feedback matters! Rate your experience and help us improve while guiding other shoppers.
            </Typography>
        </Box>
        <Box  sx={{backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(241, 240, 242, 1)', p:2, my:1, borderRadius:'16px'}}>
            <Typography variant='h6'>
            ⭐ Rate and Review Your Purchase
            </Typography>
            <Typography sx={{fontSize:'1rem', my:2}}>
                How would you rate your experience with this product/course?
            </Typography>
            <Box sx={{
                display: 'flex',
                gap:2,
                justifyContent: 'center', // Centers horizontally
                alignItems: 'center', // Centers vertically (if needed)
            }}>
                <Rating
                    name="rounded-stars"
                    value={value}
                    onChange={(event, newValue) => {
                        console.log(newValue)
                    setValue(newValue);
                    }}
                    sx={{
                        gap: '8px',
                        '& .MuiRating-iconFilled': {
                            borderRadius: '8px', // Makes the stars rounded
                        },
                        '& .MuiRating-iconHover': {
                            borderRadius: '8px', // Ensures hover stars are rounded too
                        },
                        '& .MuiRating-iconEmpty': {
                            borderRadius: '8px', // Ensures empty stars are rounded
                        }, // Adjust the gap between stars
                      }}
                />
            </Box>
            <Typography sx={{fontSize:'1rem', textAlign:'center', color:'rgba(10, 10, 10, 0.5)', mt:2}}>Tap A Star to Rate</Typography>
        </Box>
        <form>
        <Box sx={{backgroundColor:'rgba(255, 255, 255, 1)', border:'1px solid rgba(241, 240, 242, 1)', p:2, my:1, borderRadius:'16px', boxShadow:'rgba(0, 0, 0, 0.08) rgba(0, 0, 0, 0.08) rgba(0, 0, 0, 0.08) rgba(0, 0, 0, 0.08)'}}>
            <Typography sx={{my:2}}><span style={{fontWeight:'600'}}>Write a Review</span> <span style={{color:'rgba(10, 10, 10, 0.7)'}}>(optional).</span></Typography>
            <Box sx={{display:'flex', border:'1px solid rgba(0, 0, 0, 0.08)', borderRadius:'8px', py:2, px:1}}>
                <input value={description}
          onChange={handleChange} type="text" style={{outline:'none', width:'100%', boxSizing:'border-box', height:'40px', border:'none', fontSize:'1rem'}} placeholder="Tell us what you liked or how we can improve"/>
                <img src={Write} alt="" />
                {/* color:'rgba(179, 179, 179, 1)' */}
            </Box>
            </Box>
            <Box sx={{display:'flex', gap:2, my:3}}>
                <Button variant="contained"
                onClick={handleClose}
                sx={{width:'100%',display:'flex', alignItems:'center', gap:1, border:'1px solid rgba(110, 107, 123, 1)', textTransform:'none', color:'rgba(18, 18, 18, 1)', boxShadow:'none', backgroundColor:'rgba(219, 220, 221, 1)', py:1, px:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
                backgroundColor:'rgba(219, 220, 221, 1)', 
                fontWeight:600,
                boxShadow:'0px 3px 1px -2px rgba(179, 179, 179, 0.2),0px 2px 2px 0px rgba(179, 179, 179, 0.2),0px 1px 5px 0px rgba(179, 179, 179, 0.2)'
                }}}>Cancel</Button>
                <Button variant="contained"
                onClick={handleReviewSubmit}
                sx={{width:'100%',display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', py:1, px:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
                backgroundColor:'#4f03e7', 
                fontWeight:600,
                boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
                }}}>Submit Feedback</Button>
            </Box>
        </form>
    </Box>
  )
}

export default RateContent